export default __webpack_public_path__ + "static/media/barde-logo.4b83fd87.png";